import { cn } from 'utils/styles';
import Link from 'components/shared/Link/Link';

interface ArticleTagProps {
  label: string;
  href?: string;
  className?: string;
}

const tagClassName = 'w-fit font-serif font-normal text-base px-2 py-1 border border-current rounded-sm';

export const ArticleTag = ({ label, href, className }: ArticleTagProps) => {
  if (href) {
    return (
      <Link href={href} className={cn(tagClassName, 'block', className)}>
        {label}
      </Link>
    );
  }

  return <p className={cn(tagClassName, className)}>{label}</p>;
};
